// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"483":"228bb57a1a5d2e07","944":"ad37990b1ea4981c"}[chunkId] + ".js";
};